// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2xARK","label":"Completed_label__3WCRh"};